import { CalendarPlus, History } from 'lucide-react';
import { formatDisplayDateTime, formatRelativeTime } from '@/utils/date';
import type { DetailItemProps } from './DetailItem';
import { ProfileDetailSection } from './ProfileDetailSection';

interface UserTimestampsProps {
  createdAt?: string | null | undefined;
  updatedAt?: string | null | undefined;
  isLoading?: boolean | undefined;
}

export function UserTimestamps({ createdAt, updatedAt, isLoading }: UserTimestampsProps) {
  if (!isLoading && !createdAt && !updatedAt) return null;

  const fields: DetailItemProps[] = [
    {
      label: 'Created',
      value: createdAt ? formatDisplayDateTime(createdAt) : null,
      icon: CalendarPlus,
      tooltip: createdAt ? formatRelativeTime(createdAt) : null,
    },
    {
      label: 'Last updated',
      value: updatedAt ? formatDisplayDateTime(updatedAt) : null,
      icon: History,
      tooltip: updatedAt ? formatRelativeTime(updatedAt) : null,
    },
  ];

  return (
    <ProfileDetailSection
      title="Activity"
      icon={History}
      fields={fields}
      isLoading={isLoading}
      columns={2}
    />
  );
}
